import {LinearProgress} from '@material-ui/core'
import React, { useEffect } from 'react'
import { collect, isComem, isHeg, isTicOrComem, isTicTpEe, isTinOrEcg, isTinTpEe } from '../lib/utils'
import State from '../State'
import Student from '../Student'
import baseStyles from './Base.module.css'
import accueilStyles from './Accueil.module.css'
import {always, applyTo, cond, T} from "ramda";
import {makeStyles} from "@material-ui/styles";
import Form from "../Form";
import {Link} from "@reach/router";
import { getSommaireData } from "../lib/summary";
import LangAccessCodes from "../LangAccessCodes";
import { fetchAccountsStatuses } from "../lib/accounts";

const useStyles = makeStyles({
  warning: {
    border: 'solid 2px #ffe58f',
    padding: 8,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    marginBottom: 64,
  },
  bellIcon: {
    marginBottom: 16,
  },
  linkNoStyled: {
    textDecoration: "none",
    fontWeight: "500",
    color: "black"
  },
  linear: {
    display: "flex"
  },
  sommaireBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    width: "15%",
  },
  progressBox: {
    display:"flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    position: "relative"
  },
  progressText: {
    position: "absolute",
    left: "50%",
    fontSize: "small"
  }
})

export default ({ path }) => {
    const { student, setStudent } = Student.useContainer()
    const { form } = Form.useContainer()
    const { langAccessCodes = {} } = LangAccessCodes.useContainer()

  const sommaireData = getSommaireData(student);

  function processCompletion() {
    let completion = 0;
    let total = 0;
    for (let sommaireDataKey in sommaireData) {
      for (let sommaireDatumKey in sommaireData[sommaireDataKey]) {
        total++;
        const validation = processValidation(sommaireDatumKey);
        if (validation.done) {
          completion++;
        }
      }
    }
    return {
      pourcentage: 100 * completion / total,
      text: `${completion} / ${total} étapes`
    };
  }

  function processValidation(key) {

    for (const lang of ['en','de']) {
      if (key === `/profil-linguistique-${lang}`) {
        if (!student.hasOwnProperty('profilLinguistiqueSubmitted')) {
          student.profilLinguistiqueSubmitted = [];
        }
        return {
          done: student.profilLinguistiqueSubmitted.includes(lang)
        }
      }
    }

    if (!form[key]) {
      return { done: false }
    }

    if (key === '/comptes-acces') {
      return {
        done: student.passwordHasBeenModified && student.eduIDIsLinked && student.entraMfa && student.mfaConfigured
      }
    }

    if (key === '/ordinateur-portable') {
      const f = form[key]
      const flags = [f.read, f.checkedSpecs, f.checkedDevice, f.checkedOffice, f.checkedVpn, f.checkedReady]
      const checked = flags.filter(Boolean).length
      if (checked === flags.length) return { done: true }
      if (checked === 0) return { done: false }
      return { inprogress: true }
    }

    if (key === '/verification-niveaux-langues') {
      let verificationDone = true;
      const heg = isHeg(student)
      const ticOrComem = isTicOrComem(student)
      const tinOrEcg = isTinOrEcg(student)

      let showEnglish = false;

      if (heg || ticOrComem) {
        showEnglish = true;
      } else if (tinOrEcg) {
        showEnglish = student.languages === 'Anglais';
      }

      // student have english lang but dont have ask the code
      if (showEnglish && !langAccessCodes.oxford) {
        verificationDone = false;
      }

      // student dont have choice the equivalence options
      if (form[key].hasOwnProperty('requestEquivalence') && form[key]['requestEquivalence'] === undefined) {
        verificationDone = false;
      }

      if (!form[key]['read']) {
        verificationDone = false;
      }

      return {
        done: verificationDone
      }
    }

    if (key === '/preparation-a-l-immatriculation') {
      const formCheckbox = form[key]['read'];

      if (formCheckbox) {
        if (student.immatriculation) {
          return {
            done: true
          };
        } else {
          return {
            inprogress: true
          };
        }
      } else {
        return { done: false };
      }
    }

    if (student.canDebug) {
      return {
        done: false
      };
    }

    if (key === '/code-de-savoir-vivre') {
      return {
        done: form[key]['accepted']
      };
    }

    if (key === '/financement-de-vos-etudes') {
      const formCheckbox = form[key]['readAndFilledAhesForm'];
      const ahesValidated = student.ahesFin;

      if (formCheckbox) {
        if (ahesValidated) {
          return {
            done: true
          };
        } else {
          return {
            inprogress: true
          }
        }
      } else {
        return { done: false };
      }
    }

    if (form.hasOwnProperty(key)) {
      return {
        done: form[key]['read']
      };
    } else {
      return { done: false}
    }
  }

  const completionProcessed = processCompletion()
  const styles = useStyles()
  // Refresh the account statuses each time the student lands on the summary.
  // Keyed on `guid` so the call runs once the real student is loaded: on login,
  // this page mounts before `/context` has populated the student.
  useEffect(() => {
    if (!student.guid || student.canDebug) return
    fetchAccountsStatuses(student.guid)
      .then((data) => {
        if (data) {
          setStudent((prev) => ({ ...prev, ...data }))
        }
      })
      .catch((err) => console.error('Fetching account statuses failed:', err))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [student.guid, student.canDebug])
    return (
      <div className={baseStyles.root}>
        <p>
          <strong>
            Finalisez votre rentrée académique
          </strong>
        </p>
        <div className={styles.linear}>
          <div className={styles.progressBox}>
            <LinearProgress variant="determinate" value={completionProcessed.pourcentage} style={{padding: 10, borderRadius: 15}}/>
            <span className={styles.progressText}>{completionProcessed.text}</span>
          </div>
        </div>
        <p>
          Lorsque toutes les pastilles sont vertes, la préparation de votre rentrée est terminée.
        </p>
        {
          Object.keys(sommaireData).map((groupkey, i) => {
          return (
            <div key={i}>
              {i > 0 && <hr/>}
              <span className={accueilStyles.title}>{groupkey}</span>
              {Object.keys(sommaireData[groupkey]).map(key => {
                const validation = processValidation(key);
                return (
                  <div key={key} style={{display: "flex", lineHeight: "normal", paddingBottom: 11}}>
                    <State {...validation}/>
                    <div style={{paddingTop: 11, marginLeft: 15}}>
                      {sommaireData[groupkey][key].link ? (
                          <a
                            href={sommaireData[groupkey][key].link}
                            target={"_blank"}
                            className={`${styles.linkNoStyled} ${sommaireData[groupkey][key].disabled ? accueilStyles.disabled : ''}` }
                          >
                            {sommaireData[groupkey][key].title}
                          </a>
                        ) : (
                        <Link
                          className={`${styles.linkNoStyled} ${sommaireData[groupkey][key].disabled ? accueilStyles.disabled : ''}`}
                          to={'/2026' + key}>{sommaireData[groupkey][key].title}</Link>
                        )
                      }
                      <br/>
                      <span>{sommaireData[groupkey][key].subtitle}</span>
                      <span>{validation.inprogress ? sommaireData[groupkey][key].inprogresssubtitle : ''}</span>
                    </div>
                  </div>
                )
              })}
            </div>
          )
        })}
      </div>
    )
}
